import React from "react";
import { getThumbnailPath } from "../shared/getThumbnailPath";

const AboutMe = () => {
  return (
    <section id="about-me" className="section bg-linen">
      <div className="container">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 items-center">
          <div className="about-me-image">
            <img
              src={getThumbnailPath("дача_пикник_7.jpg", "lg")}
              alt="Владелица фотодачи"
              className="w-full h-auto object-cover rounded-lg shadow-lg"
            />
          </div>

          <div className="about-me-content">
            <h2 className="mb-6 text-3xl font-bold font-serif header-color md:text-4xl">
              За<b>дача</b>, у<b>дача</b> и от<b>дача</b>. Или — про нас
            </h2>

            <p className="mb-4 text-gray-700">
              Я выросла на даче. И потом мечтала о ней, кажется, всю жизнь. И
              так хотела повторить ту самую — в стародачном поселке,
              спрятавшуюся среди огромных сосен, утопающую в жасмине. Ту, где
              растут ландыши и незабудки, не боясь прилетают птицы, приходят
              белки, ежики. Где удивительная тишина и ароматы цветов и трав. Где
              время будто остановилось.
            </p>

            <p className="mb-4 text-gray-700">
              Где наливаешь чай в антикварную чашку из медного чайника. Читаешь
              дореволюционные книги и журналы прошлого века, покачиваясь в
              кресле-качалке. Носишь винтажные платья, соломенные шляпки.
              Ставишь самовар или садишься на ретро-велосипед. Накрываешь стол
              старинной кружевной скатертью или устраиваешь пикник. Выращиваешь
              цветы, ягоды, овощи. Сушишь букетики ароматных трав.
            </p>

            <p className="mb-4 text-gray-700">
              И вот однажды так и случилось. Теперь у меня — и у всех нас — есть
              дом, сад, лес. Здесь все сделано своими руками и с большой
              любовью. Эта дачка растет и меняется вместе с нами. И мы будем
              рады пригласить вас в гости и поделиться этим теплом и особенной
              атмосферой.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
